iScreenWizard.factory('c2pService', function ($state, $rootScope) {

    var service = {

        model: {
        },

        SaveState: function () {
            localStorage.c2p = angular.toJson(service.model);
        },

        RestoreState: function () {
            if (typeof localStorage.c2p !== 'undefined') {
                service.model = angular.fromJson(localStorage.c2p);
            }
        }
    };

    $rootScope.$on("savestate", service.SaveState);
    $rootScope.$on("restorestate", service.RestoreState);

    service.RestoreState();

    return service;
});